exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".YSw5L{margin-top:100px}._2LIoS{font-weight:700;margin-top:20px}._3pkNs{height:520px}.YCvqh{top:40%;bottom:auto;color:#000;font-size:26px;text-shadow:none}@media (max-width:992px){.YCvqh{right:5%;left:5%}}._2wC4D h3,.YCvqh h2{font-weight:700}._2wC4D{margin:50px auto}._2wC4D div{padding:auto 50px}._1oc-w{font-weight:700;font-size:40px}._3B0Gy{width:300px;height:300px;margin-top:50px}._17rnk{font-size:15px;padding:50px}._17rnk,.H4OZx{font-weight:700}.H4OZx{font-size:25px;color:#000;margin:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.l-sRN{margin-right:15px;margin-top:19px}._3gxon{font-size:15px;padding:0 50px}@media (min-width:992px){._17rnk{margin-top:150px}._3pkNs{height:700px}._3B0Gy{width:400px;height:400px}}@media (min-width:768px){._1oc-w{font-size:50px}}.mlqSN{position:fixed;z-index:10;right:0}._1pGwJ{height:100px;cursor:pointer}._25t-G{top:0}._1ImQM{bottom:0}.SEKLZ{display:block;height:1px;border-top:2px solid hsla(10,71%,66%,.4);margin-top:100px}._6ZOyO{margin-top:10px}._2QePM li{border:solid gray}", ""]);

// exports
exports.locals = {
	"section": "YSw5L",
	"sectionTitle": "_2LIoS",
	"carousel": "_3pkNs",
	"customCaption": "YCvqh",
	"action": "_2wC4D",
	"learnTitle": "_1oc-w",
	"learnIcon": "_3B0Gy",
	"learnText": "_17rnk",
	"linkToContact": "H4OZx",
	"connectText": "l-sRN",
	"actionItem": "_3gxon",
	"scroll": "mlqSN",
	"scrollIcon": "_1pGwJ",
	"scrollUp": "_25t-G",
	"scrollDown": "_1ImQM",
	"divider": "SEKLZ",
	"paperPlane": "_6ZOyO",
	"indicator": "_2QePM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/home/Home.css
// module id = 1306
// module chunks = 8